import * as constants from './constants';
import axios from 'axios';

export const personLoginClick = () => ({
    type: constants.PERSON_LOGIN_CLICK
})
export const companyLoginClick = () => ({
    type: constants.COMPANY_LOGIN_CLICK
})
const changePersonLogin = () => ({
    type: constants.CHANGE_PERSON_LOGIN,
    value: true
})
export const personLoginBtnClick = (account, password) => {
    return (dispatch) => {
        axios.post('https://api.chinaaudio.net.cn/UserP/tools/UserAPI/UserP/loginp?account=' + account + '&password=' + password).then((res) => {
            const result = res.data.data;
            if (result) {
                dispatch(changePersonLogin())
            } else {
                alert('登录失败')
            }
        })
    }
}


const changeCompanyLogin = () => ({
    type: constants.CHANGE_COMPANY_LOGIN,
    value: true
})
export const companyLoginBtnClick = (account, password) => {
    return (dispatch) => {
        axios.post('http://47.104.20.6:2345/api/account/buss/singin?account=' + account + '&password=' + password).then((res) => {
            const result = res.data.data;
            if (result) {
                dispatch(changeCompanyLogin())
            } else {
                alert('登录失败')
            }
        })
    }
}